<template>
    <v-container>
        <v-card flat>
            <v-card-title class="title-text">
                Historial de cambios
            </v-card-title>
            <v-col cols="12" style="overflow-y:auto; height:500px">
                <app-simple-table-with-api2
                :key="doc_id"
                :headers="headers"
                :url="'query'"
                :api_params="{ query: 'document.change.history', args: { invoice_id: doc_id }, offset: 0, limit: 1000}"
                :showSelect="false"
                :search-filters="[]"
                tableRefName="documentHistory"
                >
                </app-simple-table-with-api2>
            </v-col>
        </v-card>
    </v-container>
</template>

<script>
import AppSimpleTableWithApi2 from '@/components/layout/AppSimpleTableWithApi2.vue';

export default {
  name: 'DocumentHistoryComponent',
    components: {
        AppSimpleTableWithApi2
    },
  props: {
    doc_id: {
      type: Number,
      required: true
    }
  },
    data() {
        return {
            headers:[
            {
                text: 'Fecha',
                value: 'change_date',
                sortable: true,
            },
            {
                text: 'Estado',
                value: 'state_display',
                sortable:false
            },
            ],
        }
    },
}

</script>

<style scoped>
.title-text {
    font-size: 20px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    color:var(--v-primary-base);
}
</style>